function dispResum(str) {
    if (str && str.length > 10) {
        return str.substr(0, 16) + "...";
    }
    
    return str;
}

export default dispResum;